import { Controller } from "@hotwired/stimulus"

// F-010: ナインピース取材の Web ポスター（公開画面アコーディオン埋め込み）の
// 表示サイズを、親要素（カード）の幅に合わせて自動拡縮する。
// ポスター内部は OUTPUT_SPECS[:web]（base-width × base-height）の絶対 px で組まれているため、
// transform: scale で全体を縮める／拡大し、ラッパの width/height も合わせて更新して
// 後続要素が押し下げられないようにする。
// max-width-value（px）で拡大の上限を制御する（拡大しすぎると機種画像 :web variant が
// ぼやけるため、600px 程度で頭打ちにするのが望ましい）。
export default class extends Controller {
  static values = { baseWidth: Number, baseHeight: Number, maxWidth: Number }

  connect() {
    this.update = this.update.bind(this)
    this.observer = new ResizeObserver(this.update)
    if (this.element.parentElement) {
      this.observer.observe(this.element.parentElement)
    }
    this.update()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  update() {
    const parent = this.element.parentElement
    if (!parent || !this.baseWidthValue || !this.baseHeightValue) return
    const parentWidth = parent.clientWidth
    if (!parentWidth) return
    const targetWidth = this.maxWidthValue
      ? Math.min(parentWidth, this.maxWidthValue)
      : parentWidth
    const scale = targetWidth / this.baseWidthValue
    const viewport = this.element.querySelector(".poster-viewport")
    if (!viewport) return
    viewport.style.transformOrigin = "top left"
    viewport.style.transform = `scale(${scale})`
    this.element.style.width = `${this.baseWidthValue * scale}px`
    this.element.style.height = `${this.baseHeightValue * scale}px`
  }
}
